import $ from 'jquery';
import _ from 'lodash-es';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';

const product_carousels = {};
const product_thumbs = {};
const quickview_carousels = {};
const quickview_thumbs = {};

const initProductCarousel = ($carousel) => {
  const $container = $carousel.closest('[data-section-type="product"]');
  const id = $carousel.attr('id');
  const $data = $carousel.data();
  const $slides = $carousel.find('[data-product-images-slide]');

  let carousels = product_carousels;
  let thumbs = product_thumbs;

  if ($container.data('sectionId') === 'QuickView') {
    carousels = quickview_carousels;
    thumbs = quickview_thumbs;
  }

  let initial_index = $data.initialIndex || 0;
  let prev_next_buttons = $data.prevNextButtons;
  let page_dots = $data.pageDots;
  let draggable = $data.draggable;
  let wrap_around = $data.wrapAround;

  if (window.theme.breakpoints.current === 'mobile') {
    prev_next_buttons = $data.prevNextButtonsMobile;
    page_dots = $data.pageDotsMobile;
    draggable = $data.draggableMobile;
    wrap_around = $data.wrapAroundMobile;
  }
 
  if ($slides.length < 2) {
    prev_next_buttons = false;
    page_dots = false;
    draggable = false;

    $carousel.addClass('ProductImages__carousel--single');
  }

  if (carousels[id]) {
    initial_index = carousels[id].selectedIndex;
    carousels[id].destroy();
    delete carousels[id];
  }

  carousels[id] = new Flickity($carousel[0], {
    initialIndex: initial_index,
    prevNextButtons: prev_next_buttons,
    pageDots: page_dots,
    wrapAround: wrap_around,
    dragThreshold: window.theme.flickity.dragThreshold,
    imagesLoaded: true,
    lazyLoad: true,
    draggable,
    on: {
      // ready: () => {
      //   setTimeout(() => {
      //     if (!$(`#${id}`, $container).hasClass('ProductImages__carousel--active')) { return; }
      //     // This is the active carousel and it's ready, so resize and show the product images container
      //     // We have a really minor setTimeout because thumbnail carousels need to init before we fire this
      //     // They take almost no time to init, even 1 ms would probably work, but 10ms is extra safe
      //     const $thumbs_fix = $('.ProductImages__thumbs--active');
      //     $thumbs_fix.removeClass('ProductImages__thumbs--active');

      //     window.elementLoaded($(`#${id}`, $container).find('img').eq(0)[0]);
      //     window.triggerResize();
          
      //     setTimeout(() => {
      //       $thumbs_fix.addClass('ProductImages__thumbs--active');
      //     }, 50);
      //   }, 0);
      // },
      lazyLoad: (e, element) => {
        $(document).trigger('slideDidLazyLoad', element);
      },
    },
  });

  const $thumbs = $carousel.siblings(`[data-as-nav-for="#${id}"]`);

  if ($thumbs.length > 0) {
    const thumbs_id = $thumbs.attr('id');
    const $thumbs_data = $thumbs.data();

    let cell_align = $thumbs_data.cellAlign;
    prev_next_buttons = $thumbs_data.prevNextButtons;
    draggable = $thumbs_data.draggable;
    

    if (window.theme.breakpoints.current === 'mobile') {
      cell_align = $thumbs_data.cellAlignMobile;
      prev_next_buttons = $thumbs_data.prevNextButtonsMobile;
      draggable = $thumbs_data.draggableMobile;
    }

    if (thumbs[thumbs_id]) {
      initial_index = thumbs[thumbs_id].selectedIndex;
      thumbs[thumbs_id].destroy();
      delete thumbs[thumbs_id];
    }

    if ($slides.length > 1) {
      let all_thumbs_visible = true;
      const initial_offset_top = $thumbs.children().eq(0).offset().top;

      // Before the carousel inits, the thumbs are just normal inline blocks.
      // If there are more than will fit in the container, they will push to another line.
      // In other words, if their offset top changes, we know we have more thumbs than we can see at one time.
      $thumbs.children().each((i, thumb) => {
        if ($(thumb).offset().top !== initial_offset_top) {
          all_thumbs_visible = false;
        }
      });

      if (all_thumbs_visible) {
        wrap_around = false;
        prev_next_buttons = false;
        draggable = false;
      }

      $thumbs.removeClass('ProductImages__thumbs--has-arrows');
      
      if (prev_next_buttons) {
        $thumbs.addClass('ProductImages__thumbs--has-arrows');
      }

      thumbs[thumbs_id] = new Flickity($thumbs[0], {
        asNavFor: $thumbs_data.asNavFor,
        initialIndex: initial_index,
        prevNextButtons: prev_next_buttons,
        wrapAround: wrap_around,
        dragThreshold: window.theme.flickity.dragThreshold,
        cellAlign: cell_align,
        contain: true,
        pageDots: false,
        draggable,
        on: {
          change: (index) => {
            if (carousels[id].selectedIndex !== index) {
              carousels[id].select(index);
            }
          },
        },
      });
    } else {
      $thumbs.addClass('ProductImages__thumbs--empty');
    }
  }

  // Clone slide data to any siblings that may need it
  // For example, if a variant has 3 images, you select the first one in Shopify, and then the following 2 images are "unassigned"
  // Then you hope that the carousel is smart enough to group those 3 images together until the next "assigned" variant image shows up
  // That "smart" bit is what's below:
  let $recent_slide_data;

  $slides.each((i, slide) => {
    const $slide_data = $(slide).data();
    
    if (Object.keys($slide_data).length > 1) {
      $recent_slide_data = $slide_data;
      return;
    }

    $(slide).data($recent_slide_data);
  });

  // Smart change of option selectors as images change
  carousels[id].on('change', () => {
    const $slide = $carousel.find('.is-selected');
    const option1s = [];
    const option2s = [];
    const $slide_data = $slide.data();

    if ($slide_data.ignoreVariants) { return; }

    _.each($slide_data, (value, key) => {
      if (key.indexOf('variant') < 0) {
        return;
      }
      
      option1s.push(encodeURIComponent(value.option1));
      option2s.push(encodeURIComponent(value.option2));
    });

    if ($('[data-custom-variant-selector]', $container).is('select')) {
      const current_option1 = $('[data-custom-option-selector="option1"] select', $container).val();
      const current_option2 = $('[data-custom-option-selector="option2"] select', $container).val();
      const $selectric1 = $('[data-custom-option-selector="option1"] [data-custom-variant-selector]', $container);
      const $selectric2 = $('[data-custom-option-selector="option2"] [data-custom-variant-selector]', $container);

      if (option1s.indexOf(encodeURIComponent(current_option1)) < 0) {
        $selectric1.val(decodeURIComponent(option1s[0])).selectric('refresh').trigger('change');
      }

      if (option2s.indexOf(encodeURIComponent(current_option2)) < 0) {
        $selectric2.val(decodeURIComponent(option2s[0])).selectric('refresh').trigger('change');
      }

    } else {
      const current_option1 = $('[data-custom-option-selector="option1"] .ProductOption__variant--selected', $container).data('value');
      const current_option2 = $('[data-custom-option-selector="option2"] .ProductOption__variant--selected', $container).data('value');

      if (option1s.indexOf(encodeURIComponent(current_option1)) < 0) {
        $(`[data-custom-variant-selector][data-value="${decodeURIComponent(option1s[0])}"]`, $container).trigger('click');
      }

      if (option2s.indexOf(encodeURIComponent(current_option2)) < 0) {
        $(`[data-custom-variant-selector][data-value="${decodeURIComponent(option2s[0])}"]`, $container).trigger('click');
      }
    }
  });
};

const initProductCarousels = (type) => {
  const $carousels = $('[data-product-images-carousel]');

  if ($carousels.length > 0) {
    // Basic memory management...delete any previous quickview carousels if they exist
    if (type === 'QuickView') {
      _.each(quickview_carousels, (carousel, id) => {
        carousel.destroy();
        delete quickview_carousels[id];
      });
      _.each(quickview_thumbs, (carousel, id) => {
        carousel.destroy();
        delete quickview_thumbs[id];
      });
    }

    $carousels.each((i, carousel) => {
      initProductCarousel($(carousel));
    });

    $(document).trigger('productOverviewCarouselsDidInit', { 
      carousels: type === 'QuickView' ? quickview_carousels : product_carousels,
      thumbs: type === 'QuickView' ? quickview_thumbs : product_thumbs,
    });
  }
};

export {
  product_carousels,
  product_thumbs,
  quickview_carousels,
  quickview_thumbs,
  initProductCarousel,
  initProductCarousels,
};